// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --vm-accent: var(--color-primary);
  --vm-accent-mid: var(--color-primary);
  --vm-accent-bg: var(--color-primary-alpha-18);
  --vm-active-bg: #f0f3ff;
  --vm-hover-bg: #f6f7ff;
  --vm-text: #5a6888;
  --vm-text-active: var(--color-primary);
  --vm-text-dim: #8898b8;
  --vm-text-strong: #1a2060;
  --vm-icon-rest: #f0f2fc;
  --vm-icon-hover: var(--color-primary-alpha-18);
  --vm-icon-active: var(--color-primary);
  --vm-icon-color-rest: #b0bcd8;
  --vm-icon-color-act: #ffffff;
  --vm-sub-line: #eef0fc;
  --vm-divider: #f0f3fc;
  --vm-radius: 9px;
  --vm-radius-icon: 8px;
  --vm-speed: 150ms;
  --vm-speed-sub: 280ms;
  --vm-ease: cubic-bezier(0.16, 1, 0.3, 1);
  display: block;
  font-family: "Figtree", system-ui, sans-serif;
}

.menu-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
}

.menu-group-label {
  font-family: "DM Sans", sans-serif;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--vm-text-dim);
  padding: 12px 8px 5px;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

.menu-link {
  position: relative;
  width: 100%;
  min-height: 42px;
  border: 0;
  border-radius: var(--vm-radius);
  background: transparent;
  color: var(--vm-text);
  text-decoration: none;
  padding: 6px 10px 6px 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12.5px;
  font-weight: 500;
  text-align: start;
  cursor: pointer;
  transition: background var(--vm-speed) ease, color var(--vm-speed) ease;
  box-sizing: border-box;
}

.menu-link::before {
  content: "";
  position: absolute;
  left: 0;
  top: 18%;
  bottom: 18%;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--vm-accent);
  transform: scaleY(0);
  transform-origin: center;
  transition: transform 200ms var(--vm-ease), opacity var(--vm-speed);
  opacity: 0;
}

.menu-link:hover {
  background: var(--vm-hover-bg);
  color: var(--vm-text-active);
}
.menu-link:hover .menu-title {
  color: #d4af37; /* Gold color on hover */
}

.menu-link:hover::before {
  transform: scaleY(0.5);
  opacity: 0.5;
}

.menu-link.active-link {
  background: var(--vm-active-bg);
  color: var(--vm-text-active);
  font-weight: 600;
}

.menu-link.active-link::before {
  transform: scaleY(1);
  opacity: 1;
}

.menu-link:focus-visible {
  outline: 2px solid var(--vm-accent);
  outline-offset: -1px;
}

.menu-icon-box {
  width: 30px;
  height: 30px;
  border-radius: var(--vm-radius-icon);
  background: var(--vm-icon-rest);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background var(--vm-speed) ease;
}

.menu-icon {
  font-size: 17px;
  line-height: 1;
  color: var(--vm-icon-color-rest);
  transition: color var(--vm-speed) ease;
}

.menu-link:hover .menu-icon-box {
  background: var(--vm-icon-hover);
}

.menu-link:hover .menu-icon {
  color: var(--vm-accent-mid);
}

.menu-link.active-link .menu-icon-box {
  background: var(--vm-icon-active);
}

.menu-link.active-link .menu-icon {
  color: var(--vm-icon-color-act);
}

.menu-title {
  flex: 1;
  line-height: 1.3;
  color: inherit;
}

.menu-chevron {
  margin-left: auto;
  font-size: 16px;
  color: var(--vm-text-dim);
  transition: transform 240ms var(--vm-ease), color var(--vm-speed) ease;
}

.menu-link.expanded .menu-chevron {
  transform: rotate(180deg);
  color: var(--vm-accent-mid);
}

.sub-menu {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  margin-left: 14px;
  border-left: 2px solid var(--vm-sub-line);
  padding-left: 6px;
  transition: max-height var(--vm-speed-sub) var(--vm-ease), opacity var(--vm-speed-sub) ease;
}

.sub-menu.show {
  max-height: 600px;
  opacity: 1;
}

:host.sub-level .menu-link {
  min-height: 36px;
  padding: 7px 10px;
  font-size: 12px;
  color: var(--vm-text-dim);
  gap: 8px;
}

:host.sub-level .menu-link:hover {
  background: #f4f6ff;
  color: var(--vm-accent-mid);
}
:host.sub-level .menu-link:hover .menu-title {
  color: #d4af37; /* Gold color on hover */
}

:host.sub-level .menu-link.active-link {
  background: #eef1ff;
  color: var(--vm-accent);
  font-weight: 600;
}

:host.sub-level .menu-icon-box {
  display: none;
}

.menu-sub-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--vm-text-dim);
  opacity: 0.5;
  flex-shrink: 0;
  transition: background var(--vm-speed) ease, opacity var(--vm-speed) ease, box-shadow var(--vm-speed) ease;
}

:host.sub-level .menu-link:hover .menu-sub-dot {
  background: var(--vm-accent-mid);
  opacity: 1;
}

:host.sub-level .menu-link.active-link .menu-sub-dot {
  background: var(--vm-accent);
  opacity: 1;
  box-shadow: 0 0 0 2px rgba(40, 53, 147, 0.18);
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/menu/vertical-menu/vertical-menu.component.scss","webpack://./../../LMS_v20_Before%20Security%20Audit%20Fixes/Edulink/src/app/theme/components/menu/vertical-menu/vertical-menu.component.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,qCAAA;EACA,6CAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,8CAAA;EACA,sCAAA;EACA,6BAAA;EACA,4BAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,wCAAA;EACA,cAAA;EACA,6CAAA;ACCF;;ADEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;ACCF;;ADEA;EACE,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;ACCF;;ADEA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uEAAA;EACA,sBAAA;ACCF;;ADEA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,wBAAA;EACA,mEAAA;EACA,UAAA;ACCF;;ADEA;EACE,8BAAA;EACA,4BAAA;ACCF;ADCE;EACE,cAAA,EAAA,wBAAA;ACCJ;;ADGA;EACE,sBAAA;EACA,YAAA;ACAF;;ADGA;EACE,+BAAA;EACA,4BAAA;EACA,gBAAA;ACAF;;ADGA;EACE,oBAAA;EACA,UAAA;ACAF;;ADGA;EACE,mCAAA;EACA,oBAAA;ACAF;;ADGA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,+BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2CAAA;ACAF;;ADGA;EACE,eAAA;EACA,cAAA;EACA,gCAAA;EACA,sCAAA;ACAF;;ADGA;EACE,gCAAA;ACAF;;ADGA;EACE,2BAAA;ACAF;;ADGA;EACE,iCAAA;ACAF;;ADGA;EACE,+BAAA;ACAF;;ADGA;EACE,OAAA;EACA,gBAAA;EACA,cAAA;ACAF;;ADGA;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,sEAAA;ACAF;;ADGA;EACE,yBAAA;EACA,2BAAA;ACAF;;ADGA;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,iBAAA;EACA,2FAAA;ACAF;;ADGA;EACE,iBAAA;EACA,UAAA;ACAF;;ADGA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;ACAF;;ADGA;EACE,mBAAA;EACA,2BAAA;ACAF;ADEE;EACE,cAAA,EAAA,wBAAA;ACAJ;;ADIA;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;ACDF;;ADIA;EACE,aAAA;ACDF;;ADIA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;EACA,0GAAA;ACDF;;ADIA;EACE,gCAAA;EACA,UAAA;ACDF;;ADIA;EACE,4BAAA;EACA,UAAA;EACA,6CAAA;ACDF","sourcesContent":[":host {\n  --vm-accent: var(--color-primary);\n  --vm-accent-mid: var(--color-primary);\n  --vm-accent-bg: var(--color-primary-alpha-18);\n  --vm-active-bg: #f0f3ff;\n  --vm-hover-bg: #f6f7ff;\n  --vm-text: #5a6888;\n  --vm-text-active: var(--color-primary);\n  --vm-text-dim: #8898b8;\n  --vm-text-strong: #1a2060;\n  --vm-icon-rest: #f0f2fc;\n  --vm-icon-hover: var(--color-primary-alpha-18);\n  --vm-icon-active: var(--color-primary);\n  --vm-icon-color-rest: #b0bcd8;\n  --vm-icon-color-act: #ffffff;\n  --vm-sub-line: #eef0fc;\n  --vm-divider: #f0f3fc;\n  --vm-radius: 9px;\n  --vm-radius-icon: 8px;\n  --vm-speed: 150ms;\n  --vm-speed-sub: 280ms;\n  --vm-ease: cubic-bezier(0.16, 1, 0.3, 1);\n  display: block;\n  font-family: 'Figtree', system-ui, sans-serif;\n}\n\n.menu-item {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 4px;\n}\n\n.menu-group-label {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--vm-text-dim);\n  padding: 12px 8px 5px;\n  user-select: none;\n  pointer-events: none;\n}\n\n.menu-link {\n  position: relative;\n  width: 100%;\n  min-height: 42px;\n  border: 0;\n  border-radius: var(--vm-radius);\n  background: transparent;\n  color: var(--vm-text);\n  text-decoration: none;\n  padding: 6px 10px 6px 8px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12.5px;\n  font-weight: 500;\n  text-align: start;\n  cursor: pointer;\n  transition: background var(--vm-speed) ease, color var(--vm-speed) ease;\n  box-sizing: border-box;\n}\n\n.menu-link::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 18%;\n  bottom: 18%;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: var(--vm-accent);\n  transform: scaleY(0);\n  transform-origin: center;\n  transition: transform 200ms var(--vm-ease), opacity var(--vm-speed);\n  opacity: 0;\n}\n\n.menu-link:hover {\n  background: var(--vm-hover-bg);\n  color: var(--vm-text-active);\n\n  .menu-title {\n    color: #d4af37; /* Gold color on hover */\n  }\n}\n\n.menu-link:hover::before {\n  transform: scaleY(0.5);\n  opacity: 0.5;\n}\n\n.menu-link.active-link {\n  background: var(--vm-active-bg);\n  color: var(--vm-text-active);\n  font-weight: 600;\n}\n\n.menu-link.active-link::before {\n  transform: scaleY(1);\n  opacity: 1;\n}\n\n.menu-link:focus-visible {\n  outline: 2px solid var(--vm-accent);\n  outline-offset: -1px;\n}\n\n.menu-icon-box {\n  width: 30px;\n  height: 30px;\n  border-radius: var(--vm-radius-icon);\n  background: var(--vm-icon-rest);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background var(--vm-speed) ease;\n}\n\n.menu-icon {\n  font-size: 17px;\n  line-height: 1;\n  color: var(--vm-icon-color-rest);\n  transition: color var(--vm-speed) ease;\n}\n\n.menu-link:hover .menu-icon-box {\n  background: var(--vm-icon-hover);\n}\n\n.menu-link:hover .menu-icon {\n  color: var(--vm-accent-mid);\n}\n\n.menu-link.active-link .menu-icon-box {\n  background: var(--vm-icon-active);\n}\n\n.menu-link.active-link .menu-icon {\n  color: var(--vm-icon-color-act);\n}\n\n.menu-title {\n  flex: 1;\n  line-height: 1.3;\n  color: inherit;\n}\n\n.menu-chevron {\n  margin-left: auto;\n  font-size: 16px;\n  color: var(--vm-text-dim);\n  transition: transform 240ms var(--vm-ease), color var(--vm-speed) ease;\n}\n\n.menu-link.expanded .menu-chevron {\n  transform: rotate(180deg);\n  color: var(--vm-accent-mid);\n}\n\n.sub-menu {\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  margin-left: 14px;\n  border-left: 2px solid var(--vm-sub-line);\n  padding-left: 6px;\n  transition: max-height var(--vm-speed-sub) var(--vm-ease), opacity var(--vm-speed-sub) ease;\n}\n\n.sub-menu.show {\n  max-height: 600px;\n  opacity: 1;\n}\n\n:host.sub-level .menu-link {\n  min-height: 36px;\n  padding: 7px 10px;\n  font-size: 12px;\n  color: var(--vm-text-dim);\n  gap: 8px;\n}\n\n:host.sub-level .menu-link:hover {\n  background: #f4f6ff;\n  color: var(--vm-accent-mid);\n\n  .menu-title {\n    color: #d4af37; /* Gold color on hover */\n  }\n}\n\n:host.sub-level .menu-link.active-link {\n  background: #eef1ff;\n  color: var(--vm-accent);\n  font-weight: 600;\n}\n\n:host.sub-level .menu-icon-box {\n  display: none;\n}\n\n.menu-sub-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--vm-text-dim);\n  opacity: 0.5;\n  flex-shrink: 0;\n  transition: background var(--vm-speed) ease, opacity var(--vm-speed) ease, box-shadow var(--vm-speed) ease;\n}\n\n:host.sub-level .menu-link:hover .menu-sub-dot {\n  background: var(--vm-accent-mid);\n  opacity: 1;\n}\n\n:host.sub-level .menu-link.active-link .menu-sub-dot {\n  background: var(--vm-accent);\n  opacity: 1;\n  box-shadow: 0 0 0 2px rgba(40, 53, 147, 0.18);\n}\n",":host {\n  --vm-accent: var(--color-primary);\n  --vm-accent-mid: var(--color-primary);\n  --vm-accent-bg: var(--color-primary-alpha-18);\n  --vm-active-bg: #f0f3ff;\n  --vm-hover-bg: #f6f7ff;\n  --vm-text: #5a6888;\n  --vm-text-active: var(--color-primary);\n  --vm-text-dim: #8898b8;\n  --vm-text-strong: #1a2060;\n  --vm-icon-rest: #f0f2fc;\n  --vm-icon-hover: var(--color-primary-alpha-18);\n  --vm-icon-active: var(--color-primary);\n  --vm-icon-color-rest: #b0bcd8;\n  --vm-icon-color-act: #ffffff;\n  --vm-sub-line: #eef0fc;\n  --vm-divider: #f0f3fc;\n  --vm-radius: 9px;\n  --vm-radius-icon: 8px;\n  --vm-speed: 150ms;\n  --vm-speed-sub: 280ms;\n  --vm-ease: cubic-bezier(0.16, 1, 0.3, 1);\n  display: block;\n  font-family: \"Figtree\", system-ui, sans-serif;\n}\n\n.menu-item {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 4px;\n}\n\n.menu-group-label {\n  font-family: \"DM Sans\", sans-serif;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--vm-text-dim);\n  padding: 12px 8px 5px;\n  user-select: none;\n  pointer-events: none;\n}\n\n.menu-link {\n  position: relative;\n  width: 100%;\n  min-height: 42px;\n  border: 0;\n  border-radius: var(--vm-radius);\n  background: transparent;\n  color: var(--vm-text);\n  text-decoration: none;\n  padding: 6px 10px 6px 8px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12.5px;\n  font-weight: 500;\n  text-align: start;\n  cursor: pointer;\n  transition: background var(--vm-speed) ease, color var(--vm-speed) ease;\n  box-sizing: border-box;\n}\n\n.menu-link::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 18%;\n  bottom: 18%;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: var(--vm-accent);\n  transform: scaleY(0);\n  transform-origin: center;\n  transition: transform 200ms var(--vm-ease), opacity var(--vm-speed);\n  opacity: 0;\n}\n\n.menu-link:hover {\n  background: var(--vm-hover-bg);\n  color: var(--vm-text-active);\n}\n.menu-link:hover .menu-title {\n  color: #d4af37; /* Gold color on hover */\n}\n\n.menu-link:hover::before {\n  transform: scaleY(0.5);\n  opacity: 0.5;\n}\n\n.menu-link.active-link {\n  background: var(--vm-active-bg);\n  color: var(--vm-text-active);\n  font-weight: 600;\n}\n\n.menu-link.active-link::before {\n  transform: scaleY(1);\n  opacity: 1;\n}\n\n.menu-link:focus-visible {\n  outline: 2px solid var(--vm-accent);\n  outline-offset: -1px;\n}\n\n.menu-icon-box {\n  width: 30px;\n  height: 30px;\n  border-radius: var(--vm-radius-icon);\n  background: var(--vm-icon-rest);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background var(--vm-speed) ease;\n}\n\n.menu-icon {\n  font-size: 17px;\n  line-height: 1;\n  color: var(--vm-icon-color-rest);\n  transition: color var(--vm-speed) ease;\n}\n\n.menu-link:hover .menu-icon-box {\n  background: var(--vm-icon-hover);\n}\n\n.menu-link:hover .menu-icon {\n  color: var(--vm-accent-mid);\n}\n\n.menu-link.active-link .menu-icon-box {\n  background: var(--vm-icon-active);\n}\n\n.menu-link.active-link .menu-icon {\n  color: var(--vm-icon-color-act);\n}\n\n.menu-title {\n  flex: 1;\n  line-height: 1.3;\n  color: inherit;\n}\n\n.menu-chevron {\n  margin-left: auto;\n  font-size: 16px;\n  color: var(--vm-text-dim);\n  transition: transform 240ms var(--vm-ease), color var(--vm-speed) ease;\n}\n\n.menu-link.expanded .menu-chevron {\n  transform: rotate(180deg);\n  color: var(--vm-accent-mid);\n}\n\n.sub-menu {\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  margin-left: 14px;\n  border-left: 2px solid var(--vm-sub-line);\n  padding-left: 6px;\n  transition: max-height var(--vm-speed-sub) var(--vm-ease), opacity var(--vm-speed-sub) ease;\n}\n\n.sub-menu.show {\n  max-height: 600px;\n  opacity: 1;\n}\n\n:host.sub-level .menu-link {\n  min-height: 36px;\n  padding: 7px 10px;\n  font-size: 12px;\n  color: var(--vm-text-dim);\n  gap: 8px;\n}\n\n:host.sub-level .menu-link:hover {\n  background: #f4f6ff;\n  color: var(--vm-accent-mid);\n}\n:host.sub-level .menu-link:hover .menu-title {\n  color: #d4af37; /* Gold color on hover */\n}\n\n:host.sub-level .menu-link.active-link {\n  background: #eef1ff;\n  color: var(--vm-accent);\n  font-weight: 600;\n}\n\n:host.sub-level .menu-icon-box {\n  display: none;\n}\n\n.menu-sub-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--vm-text-dim);\n  opacity: 0.5;\n  flex-shrink: 0;\n  transition: background var(--vm-speed) ease, opacity var(--vm-speed) ease, box-shadow var(--vm-speed) ease;\n}\n\n:host.sub-level .menu-link:hover .menu-sub-dot {\n  background: var(--vm-accent-mid);\n  opacity: 1;\n}\n\n:host.sub-level .menu-link.active-link .menu-sub-dot {\n  background: var(--vm-accent);\n  opacity: 1;\n  box-shadow: 0 0 0 2px rgba(40, 53, 147, 0.18);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
